

/* eslint-disable @typescript-eslint/no-namespace */
 export namespace Resource {
  type ResourceName= {
    name: string;
  }
  export enum DownloadStatusCode{
    SUCCESS=200,
    NOT_FOUND=80700,
    NO_ORDER=80701,
    NO_GOODS_ID=80702,
    NO_AGREEMENT=80703
  }
  export interface DownloadResponseType{
    code: DownloadStatusCode;
    data: string;
    msg: string;
  }

  export enum ResourcePermissionType {
    NO_LOGIN = 'NO_LOGIN',
    NEED_LOGIN = 'NEED_LOGIN',
    NEED_ORDER = 'NEED_ORDER',
    NEED_SIGN_AGREEMENT = 'NEED_SIGN_AGREEMENT',
  }
  export interface Detail extends ResourceName {
    id: number;
    intro: string;
    original:string;
    resourceGoodsList: ResourceGoods[];
    resourceVersionList: ResourceVersion[];
    resourceGuide:ResourceGuideType;
    specification:string;
    [key: string]: any;
  }
  export interface ResourceGoods {
    goodsId: string;
    goodsName: string;

  }

  export interface ResourceVersion extends ResourceName {
    resourceTypeList: ResourceType[];
    resourceGuideDetail?:any;
  }

  export interface ResourceType extends ResourceName {
    resourceDetails: ResourceDetail[];
  }

 export interface skuListType {
    name:string;
    url:string;
    size:string;
    id:string;
    isSelect:boolean;
  }

  export interface ResourceBaseInfo{
     resourceSize: string;
    resourceUrl: string;
    resourceVersion:string
  }

  export interface ResourcePermission {
    permissionType: ResourcePermissionType;
    isFree: boolean;
  }

  export interface ResourceGuideType{
    content:{
      name:string;
      description:string;
      sortOrder:any
    }[];
    version?:(ResourceBaseInfo&ResourcePermission)[]
  }

  export enum ResourceUrlType {
    DOWNLOAD = 1,
    LINK = 2,
  }

  export type ResourceDetail = ResourceDetailBase &ResourcePermission & ResourceBaseInfo;
  export interface ResourceDetailBase extends ResourceName {
    description: string;
    id: string;
    resourceId: string;
    urlType:ResourceUrlType;
    ifHasUrl: boolean;
    skuList?: skuListType[];
    [key: string]: any;
  }

  export interface ResourceOverview {
    categoryId: string;
    documentName:string;
    goodsName:string;
    overviewImage: string;
    resourceCount:string;
    resourceDetailCount:string;
    resourceId:string;
    toolsName:string;
  }

}
